import { render, staticRenderFns } from "./ContabilitaFatturazioneStruttureDocumentiList.vue?vue&type=template&id=a5d74bfc"
import script from "./ContabilitaFatturazioneStruttureDocumentiList.vue?vue&type=script&lang=js"
export * from "./ContabilitaFatturazioneStruttureDocumentiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports